export default __webpack_public_path__ + "static/media/welcome-profile.309ed05e.png";